import { render } from "./QueHacemos.vue?vue&type=template&id=dd9b555a"
import script from "./QueHacemos.vue?vue&type=script&lang=js"
export * from "./QueHacemos.vue?vue&type=script&lang=js"

import "./QueHacemos.vue?vue&type=style&index=0&id=dd9b555a&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__